/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { SearchCommand } from './search.command';
import { SearchDisplayService } from '../../../search/services/search-display.service';

export function searchFactory() {
    const command = new SearchCommand();
    command.setDependencies({
        searchDisplayService: inject(SearchDisplayService)
    });
    return command;
}
